export default function isObjectLike(value = {}) {
  return Object.hasOwnProperty.call(value, 'properties');
}
